
import { IAlert, RouterName } from "@/models/common";
import router from "@/router";
import $API from "@/services";
import { useStore } from "@/store";
import { CommonMutationTypes } from "@/store/modules/common/mutations";
import { useI18n } from "vue-i18n";
import { defineComponent, onMounted, reactive, ref, Ref } from "vue";
import { messageType } from "@/models/message";

export default defineComponent({
  name: "Confirm Email",
  setup() {
    const { t } = useI18n({ useScope: "global" });

    const state = reactive({
      userId: router.currentRoute.value.query?.userId,
      code: router.currentRoute.value.query?.code,
      message: t("CheckingItNow"),
    });

    const store = useStore();

    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

    onMounted(async () => {
      store.commit(CommonMutationTypes.SET_IS_LODING, true);
      if (
        Array.isArray(state.userId) ||
        !state.userId ||
        Array.isArray(state.code) ||
        !state.code
      ) {
        alert.value = {
          content: "Error",
          type: messageType.ERROR,
        };
        return;
      }

      try {
        const success = await $API.SignService.confirmEmail(state.userId, state.code);
        if (success) {
          alert.value = {
            content: t('email confirmed'),
            closable: false,
            type: messageType.INFO,
            title:' ',
            className: 'center-align-dialog',
            callback: () => {
              router.push(RouterName.SIGNIN);
            },
          };
        }
      } catch(ex:any) {
        state.message = t('impossible to confirm');
        if (ex.ResultData === "SignupFaild") {
          alert.value = {
            content: t('failed to sign up'),
            type: messageType.ERROR,
          };
        } else if (ex.ResultData === "Unable to load user") {
          alert.value = {
            content: t('failed to sign up'),
            type: messageType.ERROR,
          };
        } else if (ex.ResultData === "Error confirming email") {
          alert.value = {
            content: t('not confirmed email'),
            type: messageType.ERROR,
          };
        }
      }
      
       
      store.commit(CommonMutationTypes.SET_IS_LODING, false);
    });

    return { state, alert };
  },
  methods: {
    /**
     * alert event 확인 시 home으로 이동
     */
    clearMessage() {
      this.$router.push("/");
    },
  },
  components: {},
});
